import { useState, useEffect } from 'react';

const HeroSection = () => {
  const [bgLoaded, setBgLoaded] = useState(false);
  const bgImageUrl = 'https://public.readdy.ai/ai/img_res/2168f078654683521abeb69d67660ec3.jpg';

  // 預載入背景圖片
  useEffect(() => {
    const img = new Image();
    img.onload = () => setBgLoaded(true);
    img.src = bgImageUrl;
  }, []);

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-gray-100"
    >
      {/* 背景圖片 - 使用 lazy loading */}
      <div 
        className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-700 ${
          bgLoaded ? 'opacity-100' : 'opacity-0'
        }`}
        style={{
          backgroundImage: bgLoaded ? `url(${bgImageUrl})` : 'none'
        }}
      />
      
      {/* 載入中佔位符 */}
      {!bgLoaded && (
        <div className="absolute inset-0 bg-gradient-to-r from-gray-100 to-gray-200 animate-pulse" />
      )}

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-transparent"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="max-w-2xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            建鈞精緻搬家<br />
            <strong>新北搬家公司推薦首選</strong>
          </h1>
          
          <p className="text-lg sm:text-xl lg:text-2xl text-gray-700 mb-8 leading-relaxed">
            專業<strong>新北搬家</strong>、<strong>台北搬家</strong>服務超過10年經驗，提供<strong>桃園搬家</strong>、<strong>新竹搬家</strong>全方位服務<br />
            <strong>板橋搬家</strong>、<strong>新莊搬家</strong>、<strong>中和搬家</strong>、<strong>永和搬家</strong>、<strong>土城搬家</strong>、<strong>三重搬家</strong>、<strong>泰山搬家</strong>、<strong>五股搬家</strong>、<strong>蘆洲搬家</strong>、<strong>中山搬家</strong>、<strong>桃園搬家</strong>、<strong>中壢搬家</strong>、<strong>新竹東區搬家</strong>等地區專業搬家公司服務<br />
            <strong>廢棄物清運</strong>、<strong>垃圾清運</strong>、<strong>大型家具處理</strong>專業服務
          </p>

          {/* 🎯 新增：快速服務標籤 */}
          <div className="flex flex-wrap gap-3 mb-8">
            <div className="bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-home-4-line mr-1"></i>
              套房搬家
            </div>
            <div className="bg-emerald-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-building-line mr-1"></i>
              辦公室搬遷
            </div>
            <div className="bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-truck-line mr-1"></i>
              家庭搬遷
            </div>
            <div className="bg-emerald-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-box-3-line mr-1"></i>
              精緻搬家
            </div>
            <div className="bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-delete-bin-line mr-1"></i>
              廢棄物清運
            </div>
            <div className="bg-emerald-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-team-line mr-1"></i>
              人力搬工
            </div>
          </div>

          {/* 🎯 新增：地區型關鍵字標籤 */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 mb-8 shadow-lg">
            <h3 className="text-lg font-bold text-gray-900 mb-4">
              <i className="ri-map-pin-line text-teal-600 mr-2"></i>
              主要服務地區
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 text-sm">
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>板橋搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>新莊搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>中和搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>永和搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>土城搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>三重搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>泰山搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>五股搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>蘆洲搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>中山搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>桃園搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>中壢搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-teal-600"></i>
                <span><strong>新竹東區搬家</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                <span><strong>廢棄物清運</strong></span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <i className="ri-checkbox-circle-fill text-emerald-600"></i>
                <span><strong>垃圾清運</strong></span>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href="https://line.me/ti/p/@285yavdh"
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-green-700 transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl hover:scale-105 flex items-center justify-center gap-3"
            >
              <img 
                src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                alt="LINE" 
                className="w-6 h-6"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
              <span>LINE 免費估價</span>
            </a>
            <a 
              href="tel:0978900081"
              className="bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl hover:scale-105 flex items-center justify-center gap-3"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>0978-900-081</span>
            </a>
          </div>

          {/* 🎯 新增：信任指標 */}
          <div className="mt-8 flex flex-wrap items-center gap-6 text-gray-700">
            <div className="flex items-center gap-2">
              <i className="ri-star-fill text-yellow-500 text-xl"></i>
              <span className="font-semibold">Google 4.8分</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-user-heart-line text-teal-600 text-xl"></i>
              <span className="font-semibold">5000+ 客戶信賴</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-teal-600 text-xl"></i>
              <span className="font-semibold">24小時服務</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
